import { PayloadAction } from '../../../store.model';
import { scorePercentage } from '../../form/function/score-percentage.function';
import { LOAD_MORE_LENGTH } from '../fixture/load-more-length';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../search.action';
import { defaultState, SearchState } from '../search.state';

import { RunSearch, RunSearchResult } from './run-search.action';

export function runSearchReducer(
    state: SearchState,
    action: PayloadAction<ActionType.EVAL_SEARCH__RUN_SEARCH, RunSearch>,
): SearchState {
    return {
        ...state,
        pending: {
            ...state.pending,
            runSearch: true,
        },
        selectedSearchType: {
            value: action.payload.params.searchType,
            initialLoad: false,
        },
        selectedDateRange: {
            value: {
                start: action.payload.params.dateRangeStart,
                end: action.payload.params.dateRangeEnd,
            },
            initialLoad: false,
        },
    };
}

export function runSearchResultReducer(
    state: SearchState,
    action: PayloadAction<
        ActionType.EVAL_SEARCH__RUN_SEARCH_RESULT,
        RunSearchResult
    >,
): SearchState {
    const nextSortOptions = defaultState().sortOptions;

    try {
        const nextRows = action.payload.data;
        nextRows?.forEach((e) => {
            e.eventDate = e.eventDate == null ? null : new Date(e.eventDate);
            e.evaluationDate =
                e.evaluationDate == null ? null : new Date(e.evaluationDate);
            (e as any).percentage = scorePercentage(e.score, e.maxScore);
        });

        const nextFilteredRowsLength = LOAD_MORE_LENGTH;
        let nextFilteredRows = sortRows(nextRows, nextSortOptions);
        nextFilteredRows = nextFilteredRows.slice(0, nextFilteredRowsLength);

        const nextCanLoadMore = nextRows > nextFilteredRows;

        return {
            ...state,
            pending: {
                ...state.pending,
                runSearch: false,
            },
            rows: nextRows,
            filteredRows: nextFilteredRows,
            sortOptions: nextSortOptions,
            filteredRowsLength: nextFilteredRowsLength,
            canLoadMore: nextCanLoadMore,
        };
    } catch {
        return {
            ...state,
            pending: {
                ...state.pending,
                runSearch: false,
            },
            rows: null,
            filteredRows: null,
            sortOptions: state?.sortOptions ?? nextSortOptions,
            canLoadMore: false,
        };
    }
}
